
import { useEffect, useState, useRef } from 'react';
import { resources } from '../../utils/resources';
import Navigation from '../Navigation/Navigation';
import './BuybackPage.css';
import { useUI } from '../../hooks/useUI';
import ModalWindow from '../ModalWindow/ModalWindow';
import Withdraw from '../Withdraw/Withdraw';
import TierList from '../TierList/TierList';
import Swap from '../Swap/Swap';

const BuybackPage = (props) => {

    const { userData, openModal } = useUI();

    const [modalCloseCount, setModalCloseCount] = useState(0);

    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState('');

    function formatNumber(num) {
        // Округляем в большую сторону с точностью до 2 знаков для вычислений
        num = Math.ceil(num * 100) / 100;

        if (num >= 1_000_000) {
            // Для чисел >= 1 миллиона
            const value = Math.ceil((num / 1_000_000) * 10) / 10;
            return Number.isInteger(value) ? value.toString() + 'M' : value.toFixed(1) + 'M';
        } else if (num >= 1_000) {
            // Для чисел >= 1 тысячи
            const value = Math.ceil((num / 1_000) * 10) / 10;
            return Number.isInteger(value) ? value.toString() + 'K' : value.toFixed(1) + 'K';
        } else {
            // Для чисел < 1 тысячи
            return Math.ceil(num).toString();
        }
    }

    function getTierByAmount(amount, swap_tier) {
        if (!swap_tier || !Array.isArray(swap_tier.levels)) {
            throw new Error('Некорректная структура swap_tier');
        }
    
        const levels = swap_tier.levels;
    
        const tier = levels.find(level =>
            amount >= level.minamount && amount <= level.maxamount
        );
    
        if (tier) {
            return tier;
        }

        const sortedLevels = levels.slice().sort((a, b) => b.maxamount - a.maxamount);
        if (amount > sortedLevels[0].maxamount) {
            return sortedLevels[0];
        }
    
        return null;
    }

    const tier = getTierByAmount(userData.user_main_balance, userData.swap_tier);

    const handleModalClose = () => {
        // Откладываем увеличение счётчика на 1 секунду, чтобы анимация завершилась
        setTimeout(() => {
            setModalCloseCount((prev) => prev + 1);
        }, 1000); // Длительность анимации — 1 секунда
    };

    function openModalWithdraw() {
        setModalTitle('Withdraw');
        setModalContent(<Withdraw />);
        openModal();
    }

    function openModalTierList() {
        setModalTitle('Tier list');
        setModalContent(<TierList />);
        openModal();
    }

    function openModalSwap() {
        setModalTitle('Swap');
        setModalContent(<Swap />);
        openModal();
    }

    return (
        <div className="buybackPage" style={{ backgroundImage: `url(${resources.images.buybackIllustration})` }}>
            <div className="container">
                <div className="buybackPage__illustrationBlock">
                    <span className="buybackPage__title">Buyback liquidity begins</span>
                </div>
                <div className="buybackPage__CurrentRate" style={{ backgroundImage: `url(${resources.images.CurrentRateLight})` }}>
                    <span className="buybackPage__titleCurrentRate">Current rate</span>
                    <div className="buybackPage__blockCurrentRate">
                        <span className="buybackPage__textCurrentRate">1 BOM = {tier.percent} XLM</span>
                    </div>
                </div>
                <div className="buybackPage__MyBalance">
                    <span className="buybackPage__titleMyBalance">My balance</span>
                    <div className="buybackPage__blockMyBalance" style={{ backgroundImage: `url(${resources.images.BalanceContainerBg_1})` }}>
                        <span className="buybackPage__blockTitleMyBalance">Native XLM balance</span>
                        <div className="buybackPage__balanceMyBalance">
                            <img src={resources.icons.bag} className="buybackPage__iconMyBalance rewardCard__valueIcon" />
                            <span className="buybackPage__numberMyBalance">{formatNumber(userData.user_xlm_balance)}</span>
                        </div>
                    </div>
                    <div className="buybackPage__blockMyBalance2" style={{ backgroundImage: `url(${resources.images.BalanceContainerBg_2})` }}>
                        <span className="buybackPage__blockTitleMyBalance">Buy Back Balance</span>
                        <div className="buybackPage__balanceMyBalance">
                            <img src={resources.icons.bag} className="buybackPage__iconMyBalance rewardCard__valueIcon" />
                            <span className="buybackPage__numberMyBalance">{formatNumber(userData.user_buy_back_balance)}</span>
                        </div>
                    </div>
                    <div className="buybackPage__buttonsMyBalance">
                        <button onClick={() => openModalSwap()} className="buybackPage__buttonMyBalance">
                            <span className="buybackPage__buttonTextMyBalance">Swap</span>
                        </button>
                        <button onClick={() => openModalWithdraw()} className="buybackPage__buttonMyBalance">
                            <span className="buybackPage__buttonTextMyBalance">Withdraw</span>
                        </button>
                    </div>
                </div>
                <div className="buybackPage__TierList" style={{ backgroundImage: `url(${resources.images.TierListSection})` }}>
                    <div className="buybackPage__contentTierList">
                        <span className="buybackPage__titleTierList">Tier list</span>
                        <button onClick={() => openModalTierList()} className="buybackPage__buttonTierList">
                            <span className="buybackPage__buttonTextTierList">View</span>
                        </button>
                    </div>
                </div>
            </div>
            <Navigation />
            <ModalWindow
                key={`modal-window-${modalCloseCount}`}
                title={modalTitle}
                content={modalContent}
                onClose={handleModalClose}
            />
        </div>
    );
}

export default BuybackPage;